import { render, staticRenderFns } from "./Pcindex.vue?vue&type=template&id=60d56b5f&scoped=true"
import script from "./Pcindex.vue?vue&type=script&lang=js"
export * from "./Pcindex.vue?vue&type=script&lang=js"
import style0 from "./Pcindex.vue?vue&type=style&index=0&id=60d56b5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d56b5f",
  null
  
)

export default component.exports